module.exports = __webpack_public_path__ + "img/legalServices-10.c11b94c5.png";